// Badges for a café's archive/delete lifecycle (CafeListItem/CafeDetail
// `status`, backend app/services/cafe_lifecycle.status_of). An active café has
// no entry here and falls through to its licence/subscription badge.
export const LIFECYCLE_BADGE = {
    archived: { label: 'Archived', color: 'neutral' },
    purge_failed: { label: 'Archived · purge failed', color: 'danger' },
    purging: { label: 'Deleting…', color: 'warning' },
    purged: { label: 'Deleted', color: 'danger' },
};
